function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepCategoryPills = void 0;
var _react = _interopRequireWildcard(require("react"));
var _CategoryPills = require("../CategoryPills");
var _useLang = require("./useLang");
var _reactI18next = require("react-i18next");
var _utils = require("../../utils");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var StepCategoryPills = exports.StepCategoryPills = (0, _react.memo)(function (_ref) {
  var categoryPillOnPress = _ref.categoryPillOnPress,
    themes = _ref.themes,
    impact = _ref.impact,
    style = _ref.style,
    trackingContent = _ref.trackingContent;
  (0, _useLang.useLang)();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useContext = (0, _react.useContext)(_utils.LinkContext),
    stepsPageLinkUrl = _useContext.stepsPageLinkUrl;
  var _getHref = (0, _react.useCallback)(function (lookupSlug) {
    if (categoryPillOnPress || !stepsPageLinkUrl || !lookupSlug) {
      return undefined;
    }
    return "".concat(stepsPageLinkUrl, "?filter=").concat(lookupSlug);
  }, [categoryPillOnPress, stepsPageLinkUrl]);
  var _categoryPills = (0, _react.useMemo)(function () {
    var _items = [];
    if (impact) {
      _items.push({
        slug: impact.lookupSlug,
        label: impact.name,
        backgroundColor: impact.colorBackground,
        textColor: impact.colorForeground,
        onPress: categoryPillOnPress,
        ariaLabel: t('stepCategoryPills:categoryPillAriaLabel', {
          value: impact.name
        }),
        href: _getHref(impact.lookupSlug),
        trackingContent: trackingContent
      });
    }
    if (themes) {
      themes.forEach(function (item) {
        _items.push({
          slug: item.lookupSlug,
          label: item.name,
          backgroundColor: item.colorBackground,
          textColor: item.colorForeground,
          onPress: categoryPillOnPress,
          ariaLabel: t('stepCategoryPills:categoryPillAriaLabel', {
            value: item.name
          }),
          href: _getHref(item.lookupSlug),
          trackingContent: trackingContent
        });
      });
    }
    return _items;
  }, [_getHref, trackingContent, categoryPillOnPress, impact, t, themes]);
  return (0, _jsxRuntime.jsx)(_CategoryPills.CategoryPills, {
    style: style,
    testID: "StepCategoryPills",
    categoryPills: _categoryPills
  });
});